import axios from "axios";
import { API_BASE } from "@/lib/api";

export const DEMO_QUESTIONS = [
  "Tell me about yourself.",
  "Describe a time you handled a difficult situation at work.",
  "Why do you want this role?",
  "What is your greatest professional achievement?",
];

const KEY = "rpopro_interview_demo_used";
export const demoUsed = () => !!localStorage.getItem(KEY);
export const markDemoUsed = (result) => localStorage.setItem(KEY, JSON.stringify(result));
export const savedDemo = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };

const clamp = (n) => Math.max(35, Math.min(96, Math.round(n)));

const preview = (answer) => {
  const words = answer.trim().split(/\s+/).length;
  const nums = (answer.match(/\d/g) || []).length > 0;
  const star = ["when", "situation", "task", "i led", "i built", "result", "so that", "because"].filter((w) => answer.toLowerCase().includes(w)).length;
  const structure = clamp(50 + star * 9 + Math.min(words, 120) / 6);
  const clarity = clamp(words < 25 ? 55 : words > 220 ? 62 : 82);
  const impact = clamp(nums ? 84 : 58);
  return {
    grade: null,
    scores: [{ label: "Structure (STAR)", value: structure }, { label: "Clarity", value: clarity }, { label: "Impact", value: impact }],
    strengths: [words >= 40 ? "You gave enough detail for the interviewer to follow." : "You kept it short and to the point."],
    improve: [nums ? "Lead with the result. Put your strongest number first." : "Add a number (%, time saved, revenue, team size) to prove impact."],
    tip: "End with what you learned or how it applies to this role.",
  };
};

export const gradeAnswer = async (question, answer) => {
  try {
    const { data } = await axios.post(`${API_BASE}/public/demo/interview`, { question, answer });
    return { ...data, ai: true };
  } catch (e) {
    const s = e.response?.status;
    if (s === 429) throw new Error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "The demo is busy right now. Please try again in a minute.");
    if (s === 400 || s === 422) throw new Error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Please write a slightly longer answer.");
    if (s && s < 500 && s !== 404) throw new Error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "The demo is busy right now. Please try again in a minute.");
    return { ...preview(answer), ai: false };
  }
};
